// auto-generated by {apiBaseUrl}/tools/typescriptmodels
export class NodeResult {
	public NodeId: number = 0;
	public ParentNodeId?: number;
	public Name: string = "";
	public Description?: string;
	public DisplayText: string = "";
	public ShortDisplayText?: string;
	public Route: string = "";
	public VenueRootSubdomain?: string;
	public IconName: string = "";
	public IconOverrideImagePath?: string;
	public Moniker?: string;
	public Nodes: NodeResult[] = [];
}